import React from 'react';
import './Profile.css';

function Profile() {
  const user = {
    name: "Amir",
    email: "amir@example.com",
    accountType: "Individual",
    joined: "March 2024"
  };

  return (
    <div className="profile-container">
      <h2 className="profile-title">User Profile</h2>
      <div className="profile-info">
        <h5>Full Name</h5>
        <p>{user.name}</p>

        <h5>Email Address</h5>
        <p>{user.email}</p>

        <h5>Account Type</h5>
        <p>{user.accountType}</p>

        <h5>Member Since</h5>
        <p>{user.joined}</p>
      </div>
    </div>
  );
}

export default Profile;